<template>
  <div>
    <el-form-item label="回款部门:" :prop="deptField">
      <el-cascader
        v-model="formParam[deptField]"
        :options="deptOptions"
        :props="{ value: 'id', label: 'label', checkStrictly: true, emitPath: false }"
        :show-all-levels="false"
        placeholder="请选择回款部门"
        filterable
        clearable
        style="width: 100%"
        @change="handleDeptChange"
      />
    </el-form-item>
    <el-form-item label="回款人:" :prop="userField">
      <el-select
        v-model="formParam[userField]"
        placeholder="请选择回款人"
        filterable
        clearable
        style="width: 100%"
      >
        <el-option
          v-for="item in userOptions"
          :key="item.userId"
          :label="item.nickName"
          :value="item.userId"
        />
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
import { treeSelectWithOutDataScope } from '@/api/system/dept'
import { listUserWithOutDataScope } from '@/api/system/user'

export default {
  name: 'FundOwnerSelect',
  props: {
    formParam: {
      type: Object,
      required: true
    },
    deptField: {
      type: String,
      default: 'fundDeptId'
    },
    userField: {
      type: String,
      default: 'fundUserId'
    }
  },
  data () {
    return {
      deptOptions: [],
      userOptions: []
    }
  },
  mounted () {
    this.loadDeptOptions()
    if (this.formParam[this.deptField]) {
      this.loadUsers(this.formParam[this.deptField])
    }
  },
  methods: {
    loadDeptOptions () {
      treeSelectWithOutDataScope().then(response => {
        const options = response.data || []
        this.deptOptions = options.length === 1 && options[0].parentId === 0
          ? (options[0].children || [])
          : options
      })
    },
    loadUsers (deptId) {
      this.userOptions = []
      if (!deptId) {
        return Promise.resolve()
      }
      return listUserWithOutDataScope({ deptId }).then(response => {
        const users = response.rows || []
        this.userOptions = users.filter(item => Number(item.deptId) === Number(deptId))
      })
    },
    handleDeptChange (deptId) {
      this.$set(this.formParam, this.userField, null)
      this.loadUsers(deptId)
    },
    setSelection (deptId, userId) {
      this.$set(this.formParam, this.deptField, deptId || null)
      this.$set(this.formParam, this.userField, userId || null)
      return this.loadUsers(deptId)
    }
  }
}
</script>
